/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Side_Lp1Inputs */

const en_coinvestments_nrl_side_lp1 = /** @type {(inputs: Coinvestments_Nrl_Side_Lp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LP`)
};

/**
* | output |
* | --- |
* | "LP" |
*
* @param {Coinvestments_Nrl_Side_Lp1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_side_lp1 = /** @type {((inputs?: Coinvestments_Nrl_Side_Lp1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Side_Lp1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_side_lp1(inputs)
});
export { coinvestments_nrl_side_lp1 as "coInvestments_nrl_side_lp" }